import { useState } from "react";
import apiMaestras from "../api/Maestras/api-maestras";
import { Ciclo } from "../models/Maestras/maestras.model";

export const useGestionCiclos = () => {
    const [cantidadPaginas, setCantidadPaginas] = useState(10);
    const cambiarCantidadPaginas = (e: any, value: any) => {
        setCantidadPaginas(value);
    };

    const [ciclos, setCiclos] = useState<Ciclo[]>([])
    const obtenerCiclo = async() => {
        try {
            const ciclos = await apiMaestras.obtenerCiclos();
            setCiclos(ciclos);
        } catch (error) {
            console.log(error)
        }
    }

    return {
        cantidadpaginas: cantidadPaginas,
        cambiarCantidadPaginas,
        obtenerCiclo,
        ciclos
    } 

}
